import axios from 'axios';
import { IResponse } from '~/services/api/types';

const apiUrl = 'mihin';

export const downloadMihinAcrsFiles = (acrsVersionId: number): IResponse<Blob> =>
  axios({
    method: 'get',
    url: `${apiUrl}/acrs-files/by-acrs-version-id/${acrsVersionId}`,
    responseType: 'blob',
  });

export default {};
